/* ⚛ REACT */
import { useEffect, useRef, useState } from "react";

/* 📦 LIBS */
import { toast } from "react-toastify";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

/* 🧩 COMPONENTS */
import { Input, InputSelect, Label, Button, Modal, InputCheckbox, CustomLoading, Breadcrumb, SaveIcon, CustonModal } from "../../../Components";

/* 🔗 SERVICE */
import { CargosServices } from "../../../Services/cargosServices";

/* 🧠 REDUX */
import { useSelector } from "react-redux/es/hooks/useSelector";
import { store } from "../../../Redux/Store";
import { changeModal } from "../../../Redux/Actions";

/* 📁 ASSETS*/
import { Excluir } from "../../../Assets/icons";

/* 🎨 STYLES */
import { Container, TitleContainer, Title, ContainerRow, ContainerColumn, ImageIcon, ButtonsContainer, 
    ContainerHead, ContainerCheckbox, RowContainer } from "./styles";

/* 🔧 UTILS */
import { isValidField } from "../../../util/validate";

const ViewRole = () => {
    const { t } = useTranslation();

    document.title = t("administrative.sub-items.positions.view.document-title");

    const navigationFlow =  [
        { text: 'administrative', page: '/adm/cargos' },
        { text: 'positions', page: '/adm/cargos' },
        { text: 'position', page: null }
    ]

    let { id } = useParams();

    const user = useSelector(state => state.userReducer);
    
    const [loading, setLoading] = useState(true);
    const [locations, setLocations] = useState([]);
    const [cargo, setCargo] = useState();
    const [allPermissions, setallPermissions] = useState([]);
    const [activeModal, setActiveModal] = useState("");

    const Services = useRef(new CargosServices());
    const AllocationField = useRef();
    const AllocationValue = useRef();
    const TitleField = useRef();
    const DescriptionField = useRef();
    const TitleValue = useRef();
    const DescriptionValue = useRef();
    
    useEffect(() => {
        const getCargo = async() => {
            setLoading(true);
            let currentCargo = await Services.current.getCargo(id);
            getPermissions();
            if(currentCargo){
                setCargo(currentCargo);
                try {
                    TitleField.current.getInputDOMNode().value = currentCargo.title;
                    DescriptionField.current.getInputDOMNode().value = currentCargo.description;
                } catch (error) {
                    
                }
            }
            setLoading(false)
        }

        const getPermissions = async() => {
            let Permissions = await Services.current.getAllPermissions();
            setallPermissions(Permissions);
        }

        getCargo();
        getLocations();
    }, [id]);

    // Busca alocações que o usuário consegue visualizar
    const getLocations = async() => {
        try {
            let AllLocations = await Services.current.getLocations();
            const allAllocations = AllLocations.Entidades.map(entity => ({
                id: entity.id,
                name: entity.name,
            }))
            setLocations(allAllocations);
        } catch (error) {
            
        }
    }

    // method-spoofing
    // Salva as edições
    const Save = async() => {
        if(isValidField(TitleValue.current) && isValidField(DescriptionValue.current)){
            let form = new FormData();
            if(TitleValue.current){form.append('title', TitleValue.current)}
            if(AllocationValue.current){form.append('allocation_id', AllocationValue.current)}
            if(DescriptionValue.current){form.append('description', DescriptionValue.current)}
            form.append('_method', 'PATCH');

            await Services.current.editCargo(id, form);
        }else{
            toast(t("message.save"), {
                position: "top-center",
                type: 'info',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
            });
        }
    }

    return (
        <>  
            <Container>
                <Breadcrumb flow={navigationFlow}/>
                <TitleContainer>
                    <Title>{cargo?.title}</Title>
                </TitleContainer>
                {allPermissions.length > 0 && user.user.can.includes('role.edit') &&
                    <ContainerHead>
                        <Button text={t("buttons.configure-permissions")} width={'200px'} onClick={() => store.dispatch(changeModal('permissoes'))}/>
                    </ContainerHead>
                }

                {loading ? <CustomLoading width={'150px'} height={'150px'}/>:
                <>
                    <ContainerRow onSubmit={(e) => e.preventDefault()}>
                        <ContainerColumn>
                            <Label text={t("inputs.title.label")} aling="flex-start"/>
                            <Input 
                                aling="flex-start"
                                id='title' 
                                name='title' 
                                type="text" 
                                placeholder={t("inputs.title.placeholder")}
                                innerRef={TitleField}
                                invalidMessage={t("inputs.title.invalid-message")}
                                value={cargo?.title}
                                validationFunction={(text) => isValidField(text)}
                                onchange={(text) => TitleValue.current = text}> 
                            </Input>
                            <Label text={t("inputs.allocation-local.label")} aling="flex-start"/>
                            <InputSelect
                                key="alocacao"
                                name="alocacao"
                                id="alocacao"
                                placeholder={t("inputs.allocation-local.placeholder")}
                                invalidMessage={t("inputs.allocation-local.invalid-message")}
                                options={locations}
                                value={cargo?.allocation?.id}
                                innerRef={AllocationField}
                                validationFunction={(value) => isValidField(value)}
                                onchange={(value) => AllocationValue.current = value}>
                        </InputSelect>
                        </ContainerColumn>

                        <ContainerColumn>
                            <Label text={t("inputs.description.label")} aling="flex-start"/>
                            <Input 
                                aling="flex-start"
                                id='description' 
                                name='description' 
                                type="text" 
                                placeholder={t("inputs.description.placeholder")}
                                innerRef={DescriptionField}
                                invalidMessage={t("inputs.description.invalid-message")}
                                value={cargo?.description}
                                validationFunction={(text) => isValidField(text)}
                                onchange={(text) => DescriptionValue.current = text}> 
                            </Input>

                        </ContainerColumn>
                    </ContainerRow>

                    <ButtonsContainer>
                        {user?.user?.can?.includes('role.edit') ?
                            <Button text={t("buttons.save")} width={'150px'} icon={<SaveIcon/>} onClick={() => Save()}/>
                        :<></>}
                        {user?.user?.can?.includes('role.delete') ?
                            <Button text={t("buttons.delete")} width={'150px'} color={'white-red'} onClick={() => setActiveModal('delete-position')} icon={<ImageIcon src={Excluir}/>}/>
                        :<></>}
                    </ButtonsContainer>
                </>}

            </Container>

            <CustonModal Title={t("modal.delete-position.title")} Active={activeModal === 'delete-position'}>
                <RowContainer>
                    <Button width={'fit-content'} text={t("buttons.confirm")} disabled={true}/>
                    <Button $borderRadius={'10px'} text={t("buttons.cancel")} color={'white-red'} onClick={() => setActiveModal('')}> {t("buttons.cancel")} </Button>
                </RowContainer>
            </CustonModal>

            <Modal title={t("modal.permission-settings.title") + " " + cargo?.title} name={'permissoes'} width={'70%'} height={'90%'} >
                
                <ContainerCheckbox onSubmit={(e) => e.preventDefault()}>
                    { 
                        allPermissions.map((item, index) => (
                            <InputCheckbox key={index} id={item.id} name={item.id} text={item.title} checked={item.checked} 
                                onChange={async(value) => {
                                    if(value){
                                        await Services.current.addPermission(cargo.id, item.id);
                                        item.checked = value;
                                        return true;
                                    }else{
                                        await Services.current.removePermission(cargo.id, item.id);
                                        item.checked = value;
                                        return true;
                                    }
                                }}/>
                        ))
                    }
                </ContainerCheckbox>
                
            </Modal>
        </>
    );
}

export default ViewRole;